import { z } from "zod";

const emptyUnitCodes = new Set(["", "unknown", "unknow"]);

export const CsrIndicatorUnitCodeSchema = z
    .string()
    .nullish()
    .transform((value) => {
        const unitCode = value?.trim() ?? "";
        return emptyUnitCodes.has(unitCode.toLowerCase()) ? "" : unitCode;
    });
